import { useEffect } from 'react'

export default function DynamicScriptLoader({ scripts }) {
  useEffect(() => {
    if (!scripts) {
      return
    }

    try {
      const parser = new DOMParser()
      const doc = parser.parseFromString(scripts, 'text/html')
      const scriptTags = doc.querySelectorAll('script')

      const addedScripts = []

      scriptTags.forEach((scriptTag) => {
        const scriptEl = document.createElement('script')

        for (const attr of scriptTag.attributes) {
          scriptEl.setAttribute(attr.name, attr.value)
        }

        scriptEl.textContent = scriptTag.innerHTML

        document.head.appendChild(scriptEl)
        addedScripts.push(scriptEl)
      })

      return () => {
        addedScripts.forEach((scriptEl) => document.head.removeChild(scriptEl))
      }
    } catch (error) {
      console.error('Błąd podczas dodawania skryptów:', error)
    }
  }, [scripts])

  return null
}
